// extracted by mini-css-extract-plugin
export default {"Separator":"Separator_Separator__rAyWU","Line":"Separator_Line__UvoKF"};